import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { DisclosureTaskNameGetter, DisclosureTaskNameSetter } from '@/domains/disclosure/service/disclosure-name-manager';
import { AIDisclosureResultModel } from '@/domains/disclosure/models/disclosure-result-model';
import { TaskNameService } from '@/services/task-name-service/task-name-service';
import { I18nService } from '@telecom/shared/services/i18n';


@injectable()
export class DisclosureTaskNameManager implements DisclosureTaskNameGetter, DisclosureTaskNameSetter {
    constructor(
        @inject(AIDisclosureResultModel)
        private readonly _aiDisclosureResultModel: AIDisclosureResultModel,
        @inject(TaskNameService)
        private readonly _taskNameService: TaskNameService,
        @inject(I18nService)
        private _i18n: I18nService,
    ) {}

    async getTaskName(taskId: string): Promise<string> {
        const title = await this._taskNameService.getTaskName(taskId);
        this._aiDisclosureResultModel.update((state) => ({
            ...state,
            title,
        }));
        return title;
    }

    setTaskName(taskId: string, taskName: string): Promise<void> {
        let title = taskName || this._i18n.t('aiDisclosure.untitled');
        this._aiDisclosureResultModel.update((state) => {
            title = state.title;
            return {
                ...state,
                title: taskName,
            };
        });

        return this._taskNameService.setTaskName(taskId, taskName).catch((error) => {
            this._aiDisclosureResultModel.update((state) => ({
                ...state,
                title,
            }));
            throw error;
        });
    }
}
